import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';

import ProductsCarousel from '../../components/products-carousel/products-carousel.component';
import PromoCarousel from '../../components/promo-carousel/promo-carousel.component';
import { getProducts, getProductsPromo } from '../../services/product.service';
import { setOrderID } from '../../store/features/order/orderSlice';

import Footer from '../../components/footer/footer.component';
import Header from '../../components/header/header.component';
import { getCustomerCards } from '../../services/customer.service';
import { createOrder } from '../../services/order.service';
import { SignalRContext } from '../..';

const HomeBody = ({ storeId, cardId }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { orderId } = useSelector((state) => state.order);
    const { customerCardsData } = useSelector((state) => state.customer);
    const [hasCreatedOrder, setHasCreatedOrder] = useState(false);

    SignalRContext.useSignalREffect(
        'OrderStarted',
        (message) => {
            console.log('OrderStarted', message);
            dispatch(setOrderID(message.orderId));
            navigate('/order-created-success');
        },
        []
    );

    SignalRContext.useSignalREffect(
        'OrderCancelled',
        (message) => {
            console.log('OrderCancelled', message);
            navigate('/order-cancelled');
        },
        []
    );

    useEffect(() => {
        const createOrderCall = async () => {
            const order = await createOrder({ storeId, cardId });
            setHasCreatedOrder(false);
            if (order.status === 500) {
                navigate('/order-cancelled');
            }
        };

        if (!customerCardsData) return;

        const cardSelected = customerCardsData.find(
            (card) => card.id === parseInt(cardId)
        );
        if (!cardSelected || hasCreatedOrder) return;

        const shouldCreateOrder = storeId && cardSelected.token && !orderId;

        if (shouldCreateOrder) {
            SignalRContext.on();
            createOrderCall();
            setHasCreatedOrder(true);
        }
    }, [
        cardId,
        customerCardsData,
        dispatch,
        hasCreatedOrder,
        navigate,
        orderId,
        storeId,
    ]);

    return (
        <>
            <Header title={'Tienda'} />
            <Box
                sx={{
                    height: '100%',
                    marginBottom: '76px',
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                }}
            >
                <Grid container>
                    <Grid item xs={12} marginBottom="1rem">
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 800,
                                margin: '10px 0 0 15px',
                                color: 'pink.main',
                            }}
                        >
                            Promociones
                        </Typography>
                        <PromoCarousel />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 800,
                                margin: '10px 0 0 15px',
                                color: 'grey.main',
                            }}
                        >
                            Catálogo de Precios
                        </Typography>
                        <ProductsCarousel />
                    </Grid>
                </Grid>
            </Box>
            <Footer />
        </>
    );
};

const Home = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [params, setParams] = useState({});

    useEffect(() => {
        const storeId = searchParams.get('storeId') || '';
        const cardId = searchParams.get('cardId') || '';
        setParams({ storeId, cardId });
    }, [searchParams]);

    useEffect(() => {
        dispatch(getProductsPromo({ storeId: params.storeId }));
        dispatch(getProducts());
        dispatch(getCustomerCards());
    }, [dispatch, params]);

    return (
        <>
            <HomeBody {...params} />
        </>
    );
};

export default Home;
